<script>
import { mapActions } from "vuex";

export default {
  name: "resetExpiredLinkSection",
  data() {
    return {
      email: ""
    };
  },
  methods: {
    ...mapActions("login", ["forgot"]),
    sendNewPasswordResetEmail() {
      console.log("send new password reset email");
      var that = this;
      if (that.email == null || that.email == "") {
        that.$box.alert("", "Please fill the email address", "error");
        return;
      }
      // NOTE:  if you see 2 emails being sent out, then probably your dev database is on the production server
      that.$box.loadings();
      console.log("submit the forgot password code1");
      that.forgot({
        params: { email: that.email },
        callback: that.forgotCallback
      });
    },
    forgotCallback(res) {
      console.log("call back the forgot password code1");
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.haveSubmit = true;
        that.$box.alert(
          "",
          "An email has been sent to you with a link to reset your password!",
          "success"
        );
        that.$router.push("/newlogin");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    }
  }
};
</script>

<template>
  <el-row style="padding: 50px 16px; background-color: #2D2D2D">
    <el-col :span="24">
      <img
        class="background-image"
        loading="lazy"
        src="../../assets/AgentLoginBackground.jpg"
      />
      <div class="backdrop">
        <el-row>
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <span class="sign-in-lbl">Your link has expired</span>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <span class="para-style"
              >Please enter the email address associated with your account, we
              will send you an email with a new verification link.</span
            >
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-input v-model="email" placeholder="Email Address">
              <template slot="prepend"
                ><i class="el-icon-edit-outline"
              /></template>
            </el-input>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-button class="btn-primary" @click="sendNewPasswordResetEmail"
              >Sent</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.sign-in-lbl {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
  align-self: stretch;
}

.btn-primary {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  padding: 14px 60px;
  font: 600 20px Metropolis, sans-serif;
}

.backdrop {
  position: relative;
  padding: 20px 16px 30px 16px;
  background-color: rgba(0, 0, 0, 0.8);
}

.background-image {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.para-style {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/components/reset/resetExpiredLinkSection.vue